export default __webpack_public_path__ + "static/media/homeHero.d2fb912d.png";